module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Score/assets/pain-134694531f7a138e914455e8a1dda1fa.svg";